import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FeedInOperationMode } from '../../constants/app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
import {
  FeedInFaciltyRequestData,
  FeedInGeneratorRequestData,
  FeedInInstallationRequestData,
  FeedInInstallationTechnicalData,
  FeedInInverterRequestData,
  FeedInStorageRequestData,
} from '../jurisdiction.domain';
import { CommonService } from '../../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class TechnicalDataService {
  constructor(private commonService: CommonService, private localStorageService: LocalStorageService) {}

  getFormValues(formData: FormGroup): any {
    const data = {};
    Object.keys(formData.controls).forEach(key => {
      data[key] = formData.controls[key].value;
    });
    return data;
  }

  prepareFeedInInstallationRequestData(data: FeedInInstallationTechnicalData): FeedInInstallationRequestData {
    let compDate = data.compensation_date;
    if (data.compensation_date.toString().split('.').length === 3) {
      const date = data.compensation_date.toString().split('.');
      compDate = new Date(date[1] + '-' + date[0] + '-' + date[2]);
    }
    const requestData: FeedInInstallationRequestData = {
      application_id: this.localStorageService.getItem('application_id'),
      sk_feedin_inst_type: this.localStorageService.getItem('feedin_inst_type'),
      island_mode: data.islandMode ? '1' : '0',
      feed_in_70: data.feedGrid70 ? '1' : '0',
      alternative_measuring_concept: data.altConcept ? '1' : '0',
      generator_device_exists: data.alreadyExists ? '1' : '0',
      intended_fre: data.intendedFRE ? '1' : '0',
      storage_device_planned: data.systemPlanned ? '1' : '0',
      netconsumer_supply: data.finalConsumers ? '1' : '0',
      compensation_date: compDate
        ? compDate.getFullYear() +
          '-' +
          ('00' + (compDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('00' + compDate.getDate()).slice(-2) +
          ' ' +
          ('00' + compDate.getHours()).slice(-2) +
          ':' +
          ('00' + compDate.getMinutes()).slice(-2) +
          ':' +
          ('00' + compDate.getSeconds()).slice(-2)
        : null,
      sk_feedin_operation_mode: data.feedInOperationMode,
      sk_measuring_concept: data.concept && data.concept.value,
    };
    if (data.feedInOperationMode === FeedInOperationMode.feedInExcess) {
      requestData.sk_feedin_excess_percentage = data.feedInExcess;
    } else if (data.feedInOperationMode === FeedInOperationMode.feedInFull) {
      requestData.sk_feedin_full_percentage = data.feedInFull;
      if (data.feedInFull === 'other') {
        requestData.feedin_percentage_other = data.otherFeedInValue;
      }
    }
    return requestData;
  }

  prepareFeedInFacilityRequestData(installationId: string, attachment: AbstractControl): FeedInFaciltyRequestData {
    return {
      installation_id: installationId,
      sk_feedin_type: attachment.get('systemType').value.value,
      max_apparent_power: this.commonService.parseLocaleFractionsToStandard(attachment.get('systemMaxPower').value),
    };
  }

  prepareFeedInInverterRequestData(installationId: string, inverter: AbstractControl): FeedInInverterRequestData {
    return {
      installation_id: installationId,
      manufacturer: inverter.get('manufacturer')?.value,
      inverter_type: inverter.get('type')?.value,
      num_identical_units: inverter.get('no_of_units')?.value,
      max_apparent_power: this.commonService.parseLocaleFractionsToStandard(inverter.get('max_power').value),
    };
  }

  prepareFeedInGeneratorRequestData(installationId: string, generator: AbstractControl): FeedInGeneratorRequestData {
    return {
      installation_id: installationId,
      manufacturer: generator.get('manufacturer')?.value,
      generator_type: generator.get('type')?.value,
      num_identical_units: generator.get('no_of_units')?.value,
      max_apparent_power: this.commonService.parseLocaleFractionsToStandard(generator.get('max_power').value),
    };
  }

  prepareFeedInStorageRequestData(installationId: string, storage: AbstractControl): FeedInStorageRequestData {
    return {
      installation_id: installationId,
      manufacturer: storage.get('manufacturer')?.value,
      storage_type: storage.get('type')?.value,
      num_identical_units: storage.get('no_of_units')?.value,
      max_apparent_power: this.commonService.parseLocaleFractionsToStandard(storage.get('max_power').value),
    };
  }
}
